<div id="chartmapwithanimation"  [ngStyle]="isDarkTheme ?{'background':'#212529'} : {'background-color': '#fafafa'}"></div>
